/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import cn from "clsx";
import React from "react";
import Button from "@mui/material/Button";
import styles from "../reviews.module.scss";

import { styled } from "@mui/material/styles";
import { UploadMediaProps } from "../types";
import { uploadVideo } from "@/app/csr-src/apis/profile/review.api";
import { PropsWithChildren, useState, useMemo, useEffect } from "react";
import ImgIconSvg from "@/assets/icons/img.svg";
import VideoIconSvg from "@/assets/icons/video.svg";
import DeleteIconSvg from "@/assets/icons/delete.svg";
import UKToast from "@/components/UKToast/index";
import { imageUtil } from "@/utils/imageUtil";
import { imageUploadApi } from "@/common-components-src/api/image/index.api";

import VideoPlayer from "@/components/videoDom";
import ViewImage from "@/components/viewImage";
import { useTranslation } from "@/i18n/client";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  top: 0,
  right: 0,
  whiteSpace: "nowrap",
  zIndex: 100,
});

// 上传图片按钮；
const UploadBtn = ({
  accept,
  children,
  multiple = false,
  reUpload = false,
  onChange,
}: PropsWithChildren & {
  accept: string;
  multiple?: boolean;
  onChange?: (fileList: string[] | null) => void;
  reUpload?: boolean;
}) => {
  // const [fileList, setFileList] = useState<FileList | null>(null);
  // 上传图片方法；
  const onChangeUploadImg = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const fileList = e.target?.files;
    if (!fileList?.length) {
      return null;
    }
    if (accept === 'image/*') {
      onChange?.(fileList as any);
       // 重置input
    e.target.value = '';
    } else if (accept === 'video/*') {
      onChange?.(fileList as any);
    }
   
    return null;
  };
  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={children}
      sx={{
        "&": {
          display: "block",
          background: "none",
          boxShadow: "none",
          padding: "0",
          "&:hover": {
            boxShadow: "none",
          },
        },
        "& .MuiButton-startIcon": {
          margin: 0,
        },
        "& .MuiButton-startIcon>*:nth-of-type(1)": {
          fontSize: "14px",
        },
      }}
    >
      <VisuallyHiddenInput type="file" onChange={(event) => onChangeUploadImg(event)} multiple={multiple} accept={accept} />
    </Button>
  );
};

export default function IntlUploadMedia({
  moduleType,
  onChange,
  onUpload,
  data,
  type = "image",
  apiType = 1,
  limitNumber = 8,
  limitVideoNumber = 1,
}: UploadMediaProps) {
  const [mediaList, setMediaList] = useState<Record<string, string[]> | null>(null);
  const [showRetryButtons, setShowRetryButtons] = useState<any>({});
  const [showVideoUpload, setShowVideoUpload] = useState(true);
  const [showImageUpload, setShowImageUpload] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const maxSize = 5 * 1024 * 1024;

  const hasReviewBtnStyle = useMemo(() => {
    if (isLoading) {
      return false;
    }
    return moduleType === "REVIEW" && mediaList === null;
  }, [mediaList, isLoading]);

  // 删除图片 、视频
  const onDelete = (type: string, index: number) => {
    const cloneMediaList = [...(mediaList?.[type] || [])];
    cloneMediaList.splice(index, 1);
    if (cloneMediaList?.["2"]?.length <= 0 && cloneMediaList?.["0"]?.length <= 0) {
      setMediaList(null);
    } else {
      setMediaList({
        ...mediaList,
        [type]: cloneMediaList,
      });
      if (type === "2") {
        const videoIdList = [...(mediaList?.["1"] || [])];
        videoIdList.splice(index, 1);
        setMediaList((prevData: any) => ({
          ...prevData,
          1: videoIdList,
          2: cloneMediaList,
        }));
      }
    }
  };

  // 上传图片
  const onUploadChange = async (type: string, fileList: any, index?: any) => {
    onUpload?.({ isLoading: true, showRetryButtons: showRetryButtons });
    const fileListClone = [...fileList];
    // type 0 图片
    if (type === "0") {
      setIsLoading(true);
      if (fileListClone && fileListClone.length > 0) {
        for (let index = 0; index < fileListClone.length; index++) {
          const file = fileListClone[index];
          if (file.size > maxSize) {
            // 文件大于5M，进行压缩
            await imageUtil
              .compressImage(file, maxSize)
              .then((compressedFile: any) => {
                fileListClone[index] = compressedFile;
              })
              .catch((error: any) => {
                fileListClone.splice(index, 1);
                UKToast.show({
                  icon: "error",
                  // @ts-ignore
                  content: <span>{t("upload.imageMaximum")}</span>,
                });
                console.error("img compress error: ", error);
              });
          }
        }
      }
      if (!fileListClone || fileListClone.length <= 0) {
        return;
      }
      const imgList: any = await Promise.all(fileListClone.map((file) => imageUploadApi(file, apiType)));
      const imgUrlList = imgList.map((res: { msg: string; id: string }) => (res?.id === "1" ? res!.msg : ""));
      setIsLoading(false);
      onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
      if (index >= 0) {
        if (mediaList?.["0"]?.length) {
          const cloneMediaList = [...(mediaList?.["0"] || [])];
          cloneMediaList.splice(index, 1, ...(imgUrlList || []));
          handleImageSuccess(index);
          setMediaList((prevData: any) => ({
            ...prevData,
            0: cloneMediaList,
          }));
        }
      } else {
        // const limit = mediaList?.["0"]?.length ? 8 : 9;
        setIsLoading(false);
        onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
        let num = limitNumber;
        if (mediaList?.["1"] && mediaList?.["1"].length <= 0) {
          num = limitNumber + limitVideoNumber;
        }
        setMediaList((prevData: any) => ({
          ...prevData,
          0: [...(mediaList?.["0"] || []), ...(imgUrlList || [])].slice(0, num),
        }));
      }
    }
  };

  // 上传视频
  const onUploadVideoChange = async (fileList: any) => {
    setIsLoading(true);
    onUpload?.({ isLoading: true, showRetryButtons: showRetryButtons });
    if (fileList[0].size > 1024 * 1024 * 15) {
      UKToast.show({
        icon: "error",
        content: t("upload.videoSizeLimit"),
      });
      setIsLoading(false);
      onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
      return;
    }
    let duration: number = 0;
    const url = URL.createObjectURL(fileList[0]);
    const fileElement = new Audio(url);
    // 获取视频时长
    fileElement.addEventListener("loadedmetadata", async function () {
      duration = fileElement.duration; // 得到视频或音频的时长，单位秒
      if (duration > 15) {
        setIsLoading(false);
        onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
        UKToast.show({
          icon: "error",
          content: t("upload.durationLimit"),
        });
        return;
      } else if (duration < 1) {
        setIsLoading(false);
        onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
        UKToast.show({
          icon: "error",
          content: t("upload.videoMinimum"),
        });
        return;
      } else {
        console.log(fileList,'1111')
        try {
          const res = await uploadVideo(fileList, data);
          setIsLoading(false);
          onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
          setMediaList((prevData: any) => ({
            ...prevData,
            1: [res?.videoId, ...(prevData?.["1"] || [])].slice(0, limitVideoNumber),
            2: [res?.videoUrl, ...(prevData?.["2"] || [])].slice(0, limitVideoNumber),
          }));
        } catch (error) {
          setIsLoading(false);
        }
      }
    });
  };

  useEffect(() => {
    onChange?.(mediaList, showRetryButtons);
    console.log("mediaList", mediaList);
    handleMediaUpload(mediaList);
  }, [mediaList]);

  const handleImageError = (index: number) => {
    onUpload?.({ isLoading: false, showRetryButtons: showRetryButtons });
    setShowRetryButtons((prevShowRetryButtons: any) => {
      onUpload?.({
        isLoading: false,
        showRetryButtons: {
          ...prevShowRetryButtons,
          [index]: true,
        },
      });
      return {
        ...prevShowRetryButtons,
        [index]: true,
      };
    });
  };
  const handleImageSuccess = (index: number) => {
    setShowRetryButtons((prevShowRetryButtons: any) => ({
      ...prevShowRetryButtons,
      [index]: false,
    }));
  };

  const handleMediaUpload = (list: any) => {
    const maxMediaCount = limitVideoNumber + limitNumber;
    const maxVideoCount = limitVideoNumber;
    let maxImageCount = limitNumber;
    let videoCount = 0;
    let imageCount = 0;
    // 如果没有视频的情况下
    if (list && list["1"] && list["1"].length > 0) {
      maxImageCount = limitNumber + limitVideoNumber;
    }
    if (list && list["0"] && list["0"].length > 0) {
      imageCount += list["0"].length;
    } else {
      imageCount = 0;
    }
    if (list && list["1"] && list["1"].length > 0) {
      videoCount += list["1"].length;
    } else {
      maxImageCount = limitNumber + limitVideoNumber;
      videoCount = 0;
    }
    let showVideoUpload = videoCount < maxVideoCount && imageCount + videoCount < maxMediaCount;
    let showImageUpload = imageCount < maxImageCount && imageCount + videoCount < maxMediaCount;
    if (imageCount === maxImageCount) {
      showImageUpload = false;
      showVideoUpload = false;
    } else if (videoCount === maxVideoCount) {
      showVideoUpload = false;
    }
    setShowVideoUpload(showVideoUpload);
    setShowImageUpload(showImageUpload);
  };

  const { t } = useTranslation();

  return (
    <div className={styles.mediaContainer}>
      {!!mediaList && mediaList?.["0"] && mediaList?.["0"].length > 0 && (
        <>
          {mediaList["0"].map((imgUrl: string, index: number) => (
            <div className={styles.uploadImgWrapper} key={index}>
              {/* 图片 */}
              <img
                src={imageUtil.concatImgUrlWithoutForceHttps(imgUrl, 100, 0, 100)}
                alt=""
                loading="lazy"
                onError={() => {
                  setTimeout(() => {
                    handleImageError(index);
                  }, 500);
                }}
              />
              {/* 查看图片按钮 */}
              <div className={styles.imgWrapper}>
                <span
                  className={styles.viewIcon}
                  onClick={() => {
                    setOpenImage(true);
                    setImageUrl(imgUrl);
                  }}
                >
                  {t("feedbackIndex.view")}
                </span>
              </div>
              {/* 重新上传按钮 */}
              {showRetryButtons[index] && (
                <div className={styles.imgReUpload}>
                  <UploadBtn accept="image/*" multiple onChange={(fileList) => onUploadChange("0", fileList, index)}>
                    <span style={{ display: "inline-block" }} className={styles.imgReUpload_span}>
                      {t("feedbackIndex.reUpload")}
                    </span>
                  </UploadBtn>
                </div>
              )}
              {/* 删除图片按钮 */}
              <span className={styles.delete} onClick={() => onDelete("0", index)}>
                <DeleteIconSvg />
              </span>
            </div>
          ))}
          <ViewImage open={openImage} imageUrl={imageUrl} urlList={mediaList["0"]} closeView={() => setOpenImage(false)} />
        </>
      )}
      {!!mediaList && mediaList?.["1"] && mediaList?.["1"].length > 0 && (
        <>
          {mediaList["2"].map((imgUrl: string, index: number) => (
            <div className={styles.uploadImgWrapper} key={index}>
              <VideoPlayer src={imgUrl ? imgUrl : ""} />
              <span className={styles.delete} onClick={() => onDelete("2", index)}>
                <DeleteIconSvg />
              </span>
            </div>
          ))}
        </>
      )}
      {/* 加载中 */}
      {isLoading && (
        <div className={styles.imageLoading}>
          <img src="https://st.joy-sourcing.com/website/home/loading.png" alt="" />
        </div>
      )}
      {!showImageUpload ? null : (
        <UploadBtn accept="image/*" multiple onChange={(fileList) => onUploadChange("0", fileList)}>
          <div
            className={cn(
              styles.upload,
              hasReviewBtnStyle ? styles.uploadReviewInitStyle : null,
              type !== "image_video" && hasReviewBtnStyle ? styles.uploadWidth : "",
            )}
          >
            <ImgIconSvg />
            <span>{t("feedbackIndex.uploadImage")}</span>
          </div>
        </UploadBtn>
      )}

      {type == "image_video" && (
        <>
          {!showVideoUpload ? null : (
            <UploadBtn accept="video/*" onChange={(fileList) => onUploadVideoChange(fileList)}>
              <div className={cn(styles.upload, hasReviewBtnStyle ? styles.uploadReviewInitStyle : null)}>
                <VideoIconSvg />
                <span>{t("order.orderDetail.returnRequestModal.uploadVideo")}</span>
              </div>
            </UploadBtn>
          )}
        </>
      )}
    </div>
  );
}
